import { Field, FieldAttributes } from "formik";

export default function TextareaField({ ...props }: FieldAttributes<any>) {
    return <Field as="textarea" { ...props }></Field>
}
